// extracted by mini-css-extract-plugin
export var modal = "_ie-0";